import { Box, Chip, Divider, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { ArrowDropDown } from '@mui/icons-material';
import { representationSchemeType } from 'services/constants/representationSchemeType';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { TOrderDetailsRowProps } from './types';
import { OrderDetailsRowChild } from './OrderDetailsRowChild';

export const OrderDetailsRow: FC<TOrderDetailsRowProps> = ({
	orderDetailsRow,
	paymentCurrency,
	detalization,
}) => {
	const [showAll, setShowAll] = useState(false);

	return (
		<Box
			sx={{
				border: '1px solid #00000020',
				borderRadius: '12px',
				padding: '10px',
				marginBottom: '10px',
			}}
		>
			<Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
				<Typography variant="body1" sx={{ fontWeight: 'bold' }} color="primary">
					{representationSchemeType?.[
						orderDetailsRow?.description as keyof typeof representationSchemeType
					] ?? orderDetailsRow?.description}
				</Typography>
				{orderDetailsRow?.typeOfGoods?.map((type) => (
					<Chip
						key={type}
						label={type === 'TBE' ? 'digital products' : 'goods'}
						color="primary"
						size="small"
						sx={{
							p: '0 5px',
							ml: 1,
							fontSize: '.7rem',
							height: '20px',
							backgroundColor: 'primary.light',
							color: '#000000a0',
						}}
					/>
				))}
			</Box>
			<Box sx={{ ml: 2, display: 'flex', flexDirection: 'column', gap: 0.8 }}>
				{orderDetailsRow?.children?.map((child, index) => {
					if (!showAll && index > 4) return null;
					return (
						<Box key={child.id ?? child.idProvidedByEm}>
							<OrderDetailsRowChild
								child={child}
								paymentCurrency={paymentCurrency}
								detalization={detalization}
							/>
							{index === (orderDetailsRow?.children?.length ?? 1) - 1 ? null : (
								<Divider sx={{ mt: 0.4, mb: 0.4 }} />
							)}
						</Box>
					);
				})}
				{orderDetailsRow?.children?.length > 5 && (
					<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
						<Typography
							variant="body2"
							sx={{ fontWeight: 'bold', cursor: 'pointer' }}
							color="primary"
							onClick={() => setShowAll(!showAll)}
						>
							{showAll ? 'Hide' : `Show all ${orderDetailsRow?.children?.length ?? 0} items`}
						</Typography>
						<ArrowDropDown
							sx={{
								transform: showAll ? 'rotate(180deg)' : 'rotate(0deg)',
								transition: 'transform 0.3s ease',
							}}
							color="primary"
						/>
					</Box>
				)}
			</Box>
			{(orderDetailsRow?.children?.length ?? 0) > 1 && (
				<>
					<Divider sx={{ mt: 1, mb: 1, ml: 4 }} />
					<Box sx={{ display: 'flex', justifyContent: 'end' }}>
						<Typography variant="body1" sx={{ fontWeight: 'bold' }}>
							<AmountAndCurrency
								amount={orderDetailsRow?.totalItemCost ?? 0}
								currency={paymentCurrency}
								bold
								size={1}
							/>
						</Typography>
					</Box>
				</>
			)}
		</Box>
	);
};
